import * as React from 'react';

interface ErrorBoundaryState {
    error: Nullable<Error>;
}

export class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {
    constructor(props: {}) {
      super(props);
      this.state = {
          error: null
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.setState({error});
    }

    render(): React.ReactNode {
      if (this.state.error) {
        return (
          <div className="contact-us-form__error-content">
            <h2>Something went wrong. Please try again later.</h2>
          </div>
        );
      }
      // Normally, just render children
      return this.props.children;
    }
}